export default __webpack_public_path__ + "static/media/winner-leaderboard-banner.b2478975.webp";